String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

function loadJSONProductColorSwatches() {

    const product_header = document.querySelector('.product-description-header');
    const product_key = product_header.dataset.key;
    const product_colour = product_header.dataset.colour;
    const product_style = product_header.dataset.style;

    /*
    if (product_title[0].indexOf(' in ') != -1) {
        //If product name has 'in' eg. The Suffolk Fedora in Dark Brown
        product_key = product_title[0].split(' in ')[0].toLowerCase().replace(/ /g,'-').replace(/&/g,'')
        product_colour = product_title[0].split(' in ').pop().toLowerCase().replace(/ /g,'-').replace(/&/g,'')

        if (typeof product_title[1] !== "undefined") {
            product_style = product_title[1].toLowerCase().replace(')','').replace('&','').replace(/ /g,'-').replace('-amp;','')
        }
    } else {
        if (product_title[1]) {
            //If colour in brackets eg. The Orford Fedora (Navy Ribbon)
            product_key = product_title[0].toLowerCase().replace(/ /g,'-')
            product_colour = product_title[1].toLowerCase().replace(')','').replace(' ribbon','').replace(/ /g,'-')
        } else {
            product_key = false
        }
    }*/

    swatch_count = 0

    if ( product_key ) {
        $.ajax({
            url:	"/collections/all?view=json_swatches",
            type:	'GET'
        })
            .done(function(data) {
                //console.log($.parseJSON(data));

                $.each(JSON.parse(data).results, function(index, item) {

                    var current_product = ""
                    var show_swatch = true
                    if( product_colour == item.colour ) {
                        current_product = " selected"

                        if( product_style != item.style ) {
                          show_swatch = false
                          current_product = ""
                        }
                    }

                    if ( product_colour ) {
                        console.log(product_key+'//'+item.key);
                        if ( product_key == item.key ) {
                            console.log('matched: '+product_key+'//'+item.key +'//'+ item.colour);
                            //console.log('matched: '+product_style+'//'+item.style);

                            /*
                            $('#add-to-cart-form .swatches.colour-swatches').append('<a href="'+item.url+'" data="'+item.colour+'" class="'+item.colour+current_product+'" style="background-image:url('+item.swatch+')" title="'+item.colour.replace('-', ' ').capitalize()+'"></a>');
                            swatch_count = swatch_count + 1
                            */
                            /* If we only allow catched styles */
                            if( product_style != false) {
                              console.log('test 1')
                              if( product_style == item.style ) {
                                  $('#add-to-cart-form .swatches.colour-swatches').append('<a href="'+item.url+'" data="'+item.colour+'" class="'+item.colour+current_product+'" style="background-image:url('+item.swatch+')" title="'+item.colour.replace('-', ' ').capitalize()+'"></a>');
                                  swatch_count = swatch_count + 1
                              }
                            } else {
                              console.log('test 2')
                                $('#add-to-cart-form .swatches.colour-swatches').append('<a href="'+item.url+'" data="'+item.colour+'" class="'+item.colour+current_product+'" style="background-image:url('+item.swatch+')" title="'+item.colour.replace('-', ' ').capitalize()+'"></a>');
                                swatch_count = swatch_count + 1
                            }
                        }
                    }

                });
            })
            .fail(function(data) {})
            .always(function(data) {});

    } else {
        $('#add-to-cart-form .swatches.colour-swatches').slideUp();
    }
}

if (window.location.href.indexOf('/products/') != -1 && $('.js-page-locked').length == 0) {
    $(loadJSONProductColorSwatches());
}

const colorSwatchesContainer = document.querySelector('.colour-swatches');

if ( colorSwatchesContainer ) {
  colorSwatchesContainer.addEventListener('click', function(event) {
    if (event.target.tagName === 'A') { 
      event.preventDefault();
  
      let originalHref = event.target.href;;
  
      const selectedRadio = document.querySelector('.swatches-wrapper input[type="radio"]:checked');
  
      if (selectedRadio) {
        const radioValue = selectedRadio.value;
        const newHref = originalHref +'?selected_size='+ radioValue; // Construct new URL
  
        window.location.href = newHref;
      } else {
        window.location.href = originalHref;
      }
    }
  });
}

function selectRadioFromURLParam() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  //console.log('running param: '+searchParams)
  
  if (searchParams.has('selected_size')) {
    let selectedSize = searchParams.get('selected_size');

    selectedSize = selectedSize.replace(/%20/g, " ").toLowerCase(); 

    console.log('has selected size: '+selectedSize)
    
    const radioButtons = document.querySelectorAll('.swatches-wrapper input[type="radio"]');
    radioButtons.forEach(radio => {
      const radio_value = radio.value.toLowerCase();
      if (radio_value === selectedSize) {
        radio.checked = true;
      }
    });
  }
}

selectRadioFromURLParam();

document.addEventListener('DOMContentLoaded', () => {
  const headerGroup = document.querySelector('.main-header-wrapper');
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      headerGroup.classList.add('minimise');
    }
    if (window.scrollY < 50) {
      headerGroup.classList.remove('minimise');
    }
  });

  /*
    if (headerGroup) {
        // Create a "sentinel" element to observe
        const sentinel = document.createElement('div');
        sentinel.style.position = 'absolute';
        sentinel.style.top = '0';
        sentinel.style.width = '1px';
        sentinel.style.height = '1px';

        headerGroup.parentNode.insertBefore(sentinel, headerGroup);

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    headerGroup.classList.add('minimise');
                } else {
                    headerGroup.classList.remove('minimise');
                }
            },
            { root: null, threshold: 0, rootMargin: '0px' }
        );

        observer.observe(sentinel);
    }*/
});


class AddToCart {
  constructor() {
    // Initialize and bind event listeners
    this._attachEventListeners();
  }

  async _addToCart(currentVariantID,button) {
    let formData = {
      items: [{
        id: currentVariantID,
        quantity: 1,
      }, ],
    };

    try {
      const fetchResult = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const responseJson = await fetchResult.json();

      if (!fetchResult.ok) {
        console.error('Unable to add to cart: ', responseJson);
      } else {
        button.textContent = 'Add to Bag';
        await this._updateCart();
        return responseJson;
      }
    } catch (e) {
      console.error('Unable to add to cart: ', e);
    }
  }

  async _updateCart() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      window.wetheme.updateCartDrawer(cart);
      document.querySelector('.slide-menu-cart').click();
    } catch (e) {
      console.error('Failed to update cart: ', e);
    }
  }

  _attachEventListeners() {

    const submitButtons = document.querySelectorAll('.submit-button');
    submitButtons.forEach((button) => {
      button.addEventListener('click', (event) => {

        button.textContent = 'Adding';

        event.preventDefault();

        const container = button.closest('.quick-add-container');
        const selectMenu = container.querySelector('.variants select');

        if (selectMenu) {
          const currentVariantID = selectMenu.value;
          if (currentVariantID) {
            this._addToCart(currentVariantID,button);
          }
        }
      });
    });
  }
}

new AddToCart();

const quickAddTrigger = document.querySelectorAll('.quick-add-trigger button');

quickAddTrigger.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default button behavior (if needed)

    const quickAddContainer = button.closest('.quick-add-trigger').nextElementSibling;

    if (quickAddContainer && quickAddContainer.classList.contains('quick-add-container')) {
      quickAddContainer.classList.add('active');
      //button.style.display = 'none';
    } else {
      console.error('No .quick-add-container found next to the clicked button.');
    }
  });
});

const quickAddClose = document.querySelectorAll('.close-quick-add');
quickAddClose.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default button behavior (if needed)

    const quickAddContainer = button.closest('.quick-add-container');
    quickAddContainer.classList.remove('active');
  });
});

document.querySelector('.ajax-cart--checkout-add-note p').addEventListener('click', function() {
  event.target.style.display = 'none';
  document.querySelector('.ajax-cart--checkout-add-note #note').style.display = 'block';
});

function setCartItemsHeight() {
  const cartTop = document.querySelector('.cart-drawer__top');
  const cartBottom = document.querySelector('.ajax-cart--bottom-wrapper');
  const cartItems = document.querySelector('.cart-items');

  if (cartTop && cartBottom && cartItems) {
    const topHeight = cartTop.offsetHeight;
    const bottomHeight = cartBottom.offsetHeight;
    const totalOffset = topHeight + bottomHeight;

    cartItems.style.height = `calc(100vh - ${totalOffset}px)`;
  }
}
window.addEventListener('load', setCartItemsHeight);
window.addEventListener('resize', setCartItemsHeight);